import { render, staticRenderFns } from "./InfluenceFactorView.vue?vue&type=template&id=9bf8533c&scoped=true"
import script from "./InfluenceFactorView.vue?vue&type=script&lang=js"
export * from "./InfluenceFactorView.vue?vue&type=script&lang=js"
import style0 from "./InfluenceFactorView.vue?vue&type=style&index=0&id=9bf8533c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf8533c",
  null
  
)

export default component.exports